export default __webpack_public_path__ + "media/images/images/carousel/20-bf4392fdda42c0af95a87603b8b38c78.jpg";